
import React, { } from 'react';
import styled from "styled-components";
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { getEndingAuthorizedRepresentations, getEndingRepresentations, getIsOrganizationUser, getPendingReceivedApplicationsCount } from '../../../features/basic/reducers/basicReducer';
import { useTheme } from '../../../features/context/CustomerContext';
import useCustomTranslation from '../../../features/hooks/CustomUseTranslation';

export const Nav = styled.div`
  background-color: #f1f1f1;
  height: 25px;
  width: 1020px;
  padding: 15px 0 5px 15px;
  margin: 60px auto 0px auto;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  @media screen and (min-width: 1550px) {
        width: auto;
        margin: 60px 250px 0 250px;
    }
`
export const NavItem = styled(NavLink)`
  margin-right: 20px;
  margin-bottom: 40px;
  text-decoration: none;
  color: black;
  font-weight: 400;
  padding-bottom: 10px;
  &.active {
    font-weight: 700;
    border-bottom: 6px solid ${props => props.theme.brandColor1};
  }
`

const CreateApplicationDiv = styled.div`
  border-radius: 100px;
  height: 29px;
  margin-right: 45px;
  float: right;
  padding-right: 20px;
  background-color: ${props => props.theme.brandColor1};
  position: relative;
  bottom: 9px;
  @media screen and (max-width: 1610px) {
    margin-right: 44px;
  }
}
`

export const CreateApplication = styled(NavLink)`
  font-weight: 700;
  font-size: 14px;
  top: 5px;
  position: relative;
  color: #FFFFFF;
  text-decoration:none;
  padding-left: 25px;
`

const Menu: React.FC<{}> = () => {
  const { t } = useCustomTranslation();
  const theme = useTheme();

  const isOrganizationUser = useSelector(getIsOrganizationUser);
  const pendingReceivedApplicationsCount = useSelector(getPendingReceivedApplicationsCount);
  const endingRepresentations = useSelector(getEndingRepresentations);
  const endingAuthorizedRepresentations = useSelector(getEndingAuthorizedRepresentations);

  return (
    <Nav>
      <div>
          <NavItem theme={theme} to="authorizedUsers">{t("authorizedUsers")}<span style={{ color: 'red' }}>{endingAuthorizedRepresentations ? " (!)": ""}</span></NavItem>
          <NavItem theme={theme} to="customerAuthorizations">{t("customerAuthorizations")}<span style={{ color: 'red' }}>{endingRepresentations ? " (!)": ""}</span></NavItem>
          <NavItem theme={theme} to="receivedApplications">{t("receivedApplications")}{pendingReceivedApplicationsCount && pendingReceivedApplicationsCount > 0 ? " (" + pendingReceivedApplicationsCount + ")" : ""}</NavItem>
          <NavItem theme={theme} to="sentApplications">{t("sentApplications")}</NavItem>
          {isOrganizationUser && <NavItem theme={theme} to="organizations">{t("organizations")}</NavItem>}
          <CreateApplicationDiv theme={theme}>
            <CreateApplication to="selectApplicationType">
              {t('createApplication')}
            </CreateApplication>
          </CreateApplicationDiv>
      </div>
    </Nav>
  )
}

export default Menu